import { SharedModule } from './../../../shared/shared.module';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AdvancedOptionsComponent } from './advanced-options/advanced-options.component';
import { DateSelectorComponent } from './date-selector/date-selector.component';
import { NumericInputComponent } from './numeric-input/numeric-input.component';
import { VehicleSelectorComponent } from './vehicle-selector/vehicle-selector.component';
import { VehicleGroupSelectorComponent } from './vehicle-group-selector/vehicle-group-selector.component';
import { VehicleTypeSelectorComponent } from './vehicle-type-selector/vehicle-type-selector.component';
import { TimeInputComponent } from './time-input/time-input.component';
import { VehiclesMultiSelectorComponent } from './vehicles-multi-selector/vehicles-multi-selector.component';
import { BooleanInputComponent } from './boolean-input/boolean-input.component';
import { CustomDropdownSelectorComponent } from './custom-dropdown-selector/custom-dropdown-selector.component';
import { WorkShiftSelectorComponent } from './work-shift-selector/work-shift-selector.component';
import { SetSelectorComponent } from './set-selector/set-selector.component';
import {SetGroupSelectorComponent} from './set-group-selector/set-group-selector.component';
const optionComponents = [
  AdvancedOptionsComponent,
  DateSelectorComponent,
  NumericInputComponent,
  VehicleSelectorComponent,
  VehicleGroupSelectorComponent,
  VehicleTypeSelectorComponent,
  TimeInputComponent,
  VehiclesMultiSelectorComponent,
  BooleanInputComponent,
  CustomDropdownSelectorComponent,
  WorkShiftSelectorComponent,
  SetSelectorComponent,
  SetGroupSelectorComponent,
];

@NgModule({
  declarations: [...optionComponents],
  imports: [CommonModule, SharedModule],
  exports: [...optionComponents],
})
export class ReportOptionsModule {}
